import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { AgentResolver, MicroFrontendResolver } from 'core/resolvers';
import { AgentsComponent } from './agents.component';
import { AgentCreateComponent } from './agent-create/agent-create.component';
import { AgentDetailComponent } from './agent-detail/agent-detail.component';

export const agentsRoutes: Routes = [
  {
    path: 'agents',
    title: 'agents.label',
    children: [
      {
        path: '',
        title: '',
        component: AgentsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'agents.list', microfrontends: ['GlAccounts'] },
        resolve: { glaccounts: MicroFrontendResolver }
      },
      {
        path: 'new',
        title: 'agents.create',
        component: AgentCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'agents.create', microfrontends: ['GlAccounts'] },
        resolve: { glaccounts: MicroFrontendResolver }
      },
      {
        path: ':agentId',
        title: ':agentId',
        resolve: { agent: AgentResolver },
        children: [
          {
            path: '',
            title: '',
            component: AgentDetailComponent,
            canActivate: [ProfileGuard],
            data: { action: 'agents.detail', preloader: 'secondary', microfrontends: ['GlAccounts'] },
            resolve: { glaccounts: MicroFrontendResolver }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(agentsRoutes)],
  exports: [RouterModule]
})
export class AgentsRoutingModule {}
